import React from 'react'
import { useTranslation } from '@mc/i18n'
import Nav from '@mc/navigation'
import { paths } from '@mc/paths'
import { MenuGiftingOnMobileNavExp } from '@mc/promos'
import { track, EventTypes, getPageSource } from '@mc/track-event'
import Link from 'components/Link'
import { UserState } from 'components/UserState'
import { signOut } from 'libs/client/api'
import { articlesPath, homePath } from 'libs/paths'
import { sprigLogout } from 'libs/sprig'
import { trackLoginClick } from '../events'

type LoginMenuProps = {
  children: React.ReactNode
  linkClassName?: string
}
export const LoginMenu = ({ children, linkClassName = '' }: LoginMenuProps) => {
  const { t } = useTranslation('@mc/next')

  const handleSignOutClick = (e: React.MouseEvent) => {
    e.preventDefault()
    signOut().then(() => {
      sprigLogout()
      window.location.href = homePath()
    })
  }

  const onMenuToggle = () => {
    track(EventTypes.HAMBURGER_MENU_CLICKED, {
      page_source: getPageSource(),
    })
  }

  return (
    <>
      <UserState loggedOut>
        <div className='d-none d-lg-block'>
          <Link
            href={paths.logIn()}
            className={`mc-ml-4 ${linkClassName}`}
            onClick={trackLoginClick}
          >
            {t('nav.cta.login')}
          </Link>
        </div>

        <div className='d-lg-none'>
          <MenuGiftingOnMobileNavExp
            Control={
              <Nav.Menu label={t('nav.menu')} onToggle={onMenuToggle}>
                {children}
              </Nav.Menu>
            }
            label={t('nav.menu')}
            onToggle={onMenuToggle}
          >
            {children}
          </MenuGiftingOnMobileNavExp>
        </div>
      </UserState>

      <UserState loggedIn>
        <Nav.Menu label={t('nav.menu')} className='mc-ml-0 mc-ml-lg-4'>
          <Nav.MenuLink href={paths.manageGifts}>
            {t('nav.cta.manageGifts')}
          </Nav.MenuLink>

          <Nav.MenuLink href={articlesPath()}>
            {t('nav.cta.articles')}
          </Nav.MenuLink>

          <Nav.MenuLink href={paths.settings}>
            {t('nav.cta.settings')}
          </Nav.MenuLink>

          <Nav.MenuLink href={paths.helpCenter}>
            {t('nav.cta.help')}
          </Nav.MenuLink>

          <Nav.MenuLink onClick={handleSignOutClick}>
            {t('nav.cta.signout')}
          </Nav.MenuLink>
        </Nav.Menu>
      </UserState>
    </>
  )
}
